
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      flexWrap: 'wrap',
      width: '100%', 
      padding:'0 20px 0 20px'
    }
  },
  datePickerWrapper: {
    width: '572px',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '27px',
    color: '#182e3d'
  }
}));
